import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IPrettyPDF {
	/**
	 * PrettyPDF Image - Images should be 288px X 376px
	 */
	image?: IImage;
	/**
	 * PrettyPDF Link
	 */
	link?: ILink;
}

export interface IPrettyPDFProps extends IBaseElementProps {
	children?: any;
	prettyPDFS: IPrettyPDF[];
}

/**
 * PrettyPDF
 * @block
 * @requiresHooks
 * @icon pdf
 */
const PrettyPDF: React.FC<IPrettyPDFProps> = ({
	children,
	className,
	classNames = [],
	prettyPDFS = [],
}) => (
	<div className={className || cn('pretty-pdf', ...classNames)}>
		<div className="container-fluid">
			<div className="row">
				{prettyPDFS && prettyPDFS.length > 0 && prettyPDFS.map((prettyPDF, index) => (
					<div
						key={index}
						className="pretty-pdf-item col-12 col-sm-6 col-md-3"
					>
						<script type="application/ld+json">
							{`
								{
									"@context": "http://schema.org/",
									"@type": "Article",
									"image":"${prettyPDF.image.src}",
									"name":"${prettyPDF.link.label}",
									"url":"${prettyPDF.link.href}"
								}
							`}
						</script>
						<div className="pretty-pdf-item__inner">
							{prettyPDF.link && (
								<a href={prettyPDF.link.href}>
									<div className="pretty-pdf-image__container">
										<Image
											className="img-fluid"
											{...prettyPDF.image}
										/>
									</div>
									<div className="pretty-pdf-link__container">
										<span className="pretty-pdf-link__label">
											{prettyPDF.link.label}
										</span>
										<span className="icon-download"></span>
									</div>
								</a>
							)}
						</div>
					</div>
				))}
			</div>
		</div>
	</div>
);

export default PrettyPDF;
